export default "__VITE_ASSET__CjQLAs$H__"